import React, { useCallback, useEffect, useState } from 'react';
import { ItemActionsState } from '../state';
import { CollectionItemActions } from './CollectionItemActions';
import { CollectionState, FiltersMap, KeyedItem } from '@wix/bex-core';
import { observer } from 'mobx-react-lite';
import { ActionsCell } from './ActionsCell';

export interface CollectionTableActionsColumnProps<T, F extends FiltersMap> {
  keyedItem: KeyedItem<T>;
  index: number;
  sticky?: boolean;
  actionsCell: ActionsCell<T, F>;
  collection: CollectionState<T, F>;
}

function _CollectionTableActionsColumn<T, F extends FiltersMap>(
  props: CollectionTableActionsColumnProps<T, F>,
) {
  const { collection, index, sticky, keyedItem, actionsCell, ...rest } = props;

  const [state] = useState(
    () =>
      new ItemActionsState({
        keyedItem,
        collection,
        fade: 'static',
      }),
  );

  const renderActionCell = useCallback(() => {
    const actionCellProps =
      typeof actionsCell === 'function'
        ? actionsCell(keyedItem.item, index, state.actionsCellAPI)
        : actionsCell;

    return {
      ...actionCellProps,
      popoverMenuProps: {
        // Larger zIndex than Page.Sticky https://github.com/wix-private/wix-design-systems/blob/844c42de1fb6e65f62b4b32538c5923869116d3d/packages/wix-style-react/src/Page/Page.st.css#L41
        ...(sticky && { zIndex: 1200 }),
        ...actionCellProps?.popoverMenuProps,
      },
    };
  }, [actionsCell, sticky, index, keyedItem]);

  useEffect(() => {
    state.setItemIfChanged(keyedItem);
  }, [keyedItem]);

  return (
    <CollectionItemActions
      {...rest}
      collection={state.collection}
      renderActionCell={renderActionCell}
      state={state}
    />
  );
}

export const CollectionTableActionsColumn = observer(
  _CollectionTableActionsColumn,
);
